import { Box, CardContent, Grid } from '@mui/material';
import GroupButton from 'components/Buttons/ButtonGroup';
import ContainerCard from 'components/Containers/Card/ContainerCard';
import HeaderCard from 'components/Containers/Card/HeaderCard';
import { useStyles } from 'components/Styles';
import BankData from './components/inputCategories/BankData';
import Contacts from './components/inputCategories/Contacts';
import Identification from './components/inputCategories/Identification';
import { useProvider } from './hooks/useProvider';

function Provider() {
  const classes = useStyles();

  const {
    formik,
    swithRegisterBankAccount,
    setSwithRegisterBankAccount,
    id,
    disable,
    recoverState,
  } = useProvider();

  return (
    <ContainerCard>
      <form onSubmit={formik.handleSubmit}>
        <Box className={classes.root}>
          <HeaderCard
            title="Dados do Fornecedor"
            tooltipText="Essa tela possibilita cadastrar informações relacionadas a uma empresa ou a um vendedor. Dessa forma facilitando o controle de onde e a quem você compra."
          />
          <CardContent
            sx={{
              '&.MuiCardContent-root': {
                padding: 0,
              },
            }}
          >
            <Grid container direction="column" gap={6}>
              <Grid item>
                <Identification formik={formik} recoverState={recoverState} />
              </Grid>
              <Grid item>
                <Contacts
                  formik={formik}
                  swithRegisterBankAccount={swithRegisterBankAccount}
                  onSwithRegisterBankAccount={setSwithRegisterBankAccount}
                />
              </Grid>
              {swithRegisterBankAccount && (
                <Grid item>
                  <BankData formik={formik} />
                </Grid>
              )}
            </Grid>
          </CardContent>
        </Box>
        <GroupButton
          deleteRoute="/providers/"
          routeDelete="/provider"
          returnRoute="/providers"
          id={id}
          disable={disable}
          messageDialogError
          disableTemporary={false} // Desativar o botão de delete
          message="Deletar esse fornecedor pode prejudicar informações ligadas a ele. Tem certeza que deseja excluir?"
        />
      </form>
    </ContainerCard>
  );
}

export default Provider;
